import React, { FC, useState } from 'react'
import styled from 'styled-components'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  width: 100%;
`

const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
`

const Label = styled.div`
  font-size: 0.65rem;
  color: rgba(255, 255, 255, 0.7);
  font-weight: 500;
  letter-spacing: 0.05rem;
`

const StyledInput = styled.input<{ $isFocused: boolean }>`
  height: 32px;
  padding: 6px 10px;
  font-size: 0.75rem;
  font-family: inherit;
  color: white;
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 4px;
  outline: none;
  width: 100%;
  background: ${(props) =>
    props.$isFocused ? 'rgba(255, 255, 255, 0.1)' : 'transparent'};
  transition: background-color 0.2s ease;

  &::placeholder {
    color: rgba(255, 255, 255, 0.5);
  }

  &:focus {
    border-color: rgba(255, 255, 255, 0.6);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`

interface LocationSectionProps {
  locationTransverse: string
  locationLongitudinal: string
  locationVertical: string
  onLocationChange: (
    field: 'locationTransverse' | 'locationLongitudinal' | 'locationVertical',
    value: string
  ) => void
  disabled?: boolean
}

export const LocationSection: FC<LocationSectionProps> = ({
  locationTransverse,
  locationLongitudinal,
  locationVertical,
  onLocationChange,
  disabled = false,
}) => {
  const [focusedField, setFocusedField] = useState<string | null>(null)

  return (
    <Container>
      <InputWrapper>
        <Label>TRANSVERSE</Label>
        <StyledInput
          type='text'
          placeholder='Enter transverse location'
          value={locationTransverse}
          onChange={(e) =>
            onLocationChange('locationTransverse', e.target.value)
          }
          onFocus={() => setFocusedField('transverse')}
          onBlur={() => setFocusedField(null)}
          onClick={(e) => e.stopPropagation()}
          onMouseDown={(e) => e.stopPropagation()}
          onMouseUp={(e) => e.stopPropagation()}
          onKeyDown={(e) => e.stopPropagation()}
          onKeyUp={(e) => e.stopPropagation()}
          disabled={disabled}
          $isFocused={focusedField === 'transverse'}
        />
      </InputWrapper>

      <InputWrapper>
        <Label>LONGITUDINAL</Label>
        <StyledInput
          type='text'
          placeholder='Enter longitudinal location'
          value={locationLongitudinal}
          onChange={(e) =>
            onLocationChange('locationLongitudinal', e.target.value)
          }
          onFocus={() => setFocusedField('longitudinal')}
          onBlur={() => setFocusedField(null)}
          onClick={(e) => e.stopPropagation()}
          onMouseDown={(e) => e.stopPropagation()}
          onMouseUp={(e) => e.stopPropagation()}
          onKeyDown={(e) => e.stopPropagation()}
          onKeyUp={(e) => e.stopPropagation()}
          disabled={disabled}
          $isFocused={focusedField === 'longitudinal'}
        />
      </InputWrapper>

      <InputWrapper>
        <Label>VERTICAL</Label>
        <StyledInput
          type='text'
          placeholder='Enter vertical location'
          value={locationVertical}
          onChange={(e) => onLocationChange('locationVertical', e.target.value)}
          onFocus={() => setFocusedField('vertical')}
          onBlur={() => setFocusedField(null)}
          onClick={(e) => e.stopPropagation()}
          onMouseDown={(e) => e.stopPropagation()}
          onMouseUp={(e) => e.stopPropagation()}
          onKeyDown={(e) => e.stopPropagation()}
          onKeyUp={(e) => e.stopPropagation()}
          disabled={disabled}
          $isFocused={focusedField === 'vertical'}
        />
      </InputWrapper>
    </Container>
  )
}
